import { Component } from '@angular/core';
import {
  CreatePersonData,
  OtpValidationFacadeService,
  PersonDetailsFacadeService,
} from '@qivos/qivoscloud-ion-components';
import { OtpValidation } from '@qivos/qivoscloud-ion-components/lib/models/otp-validation.model';
import { PersonDetailsForm } from '@qivos/qivoscloud-ion-components/lib/models/person-details.model';
import { Consent, Person, QivosCloudService } from '@qivos/qivoscloud-ng-api';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(
    public otpValidationFacadeService: OtpValidationFacadeService,
    public personDetailsFacadeService: PersonDetailsFacadeService,
    public qcService: QivosCloudService
  ) {}

  person = new Person();
  consentList: Consent[] = [];

  otpValidationConfig: OtpValidation = {
    mobileNumber: {
      rendered: true,
      required: false,
      label: '',
      placeholder: 'Κινητό Τηλέφωνο',
      value: '',
      validation: /^9[0-9]{7}$/,
      message:
        'Το κινητό που καταχωρήσατε δεν αντιστοιχεί σε κυπριακό αριθμό. 😕',
      disabled: false,
    },
    otp: {
      rendered: true,
      required: false,
      label: '',
      placeholder: 'Εισαγωγή Κωδικού',
      value: '',
      validation: /^\d{6}$/,
      message: 'Το OTP δεν είναι σωστό',
    },
    account: 'intersport',
    countryCode: 'cy',
    otpProfileCode: 'CY_POS_REGISTRATION',
    schemaCode: '2222',
    type: 'CUSTOMER_REGISTRATION',
    languageCode: 'en',
    sendOtpTextBtn: 'ΑΠΟΣΤΟΛΗ ΚΩΔΙΚΟΥ',
    validateOtpTextBtn: 'ΚΑΤΑΧΩΡΗΣΗ',
    showRegistrationForm: false,
    btnTextColor: 'white',
    btnColor: '#5195FF',
    userIsRegisteredMessage:
      'Παρακαλώ προσπαθήστε με άλλο αριθμό κινητού τηλεφώνου.',
    jwtToken: '',
  };

  personDetails: PersonDetailsForm = {
    mobileNumber: {
      rendered: false,
      required: false,
      label: 'Αριθμός κινητού τηλεφώνου',
      placeholder: '',
      value: '',
      validation: /^9[0-9]{7}$/,
      message: '',
      disabled: false,
    },
    gender: {
      rendered: false,
      required: false,
      label: 'Προσφώνηση',
      maleGenderLabel: 'Κύριος',
      femaleGenderLabel: 'Κυρία',
      otherGenderLabel: 'Άλλο',
      value: { Name: '', Value: '' },
    },
    firstName: {
      rendered: true,
      required: true,
      disabled: false,
      label: 'Όνομα',
      placeholder: '',
      value: '',
      validation: /^[α-ωίϊΐόάέύϋΰήώΑ-ΩΆΈΊΌΎΏΉa-zA-Zs.-]+$/,
      message: 'Τα στοιχεία που καταχωρήσατε δεν είναι σωστά 😕',
    },
    lastName: {
      rendered: true,
      required: true,
      disabled: false,
      label: 'Επώνυμο',
      placeholder: '',
      value: '',
      validation: /^[α-ωίϊΐόάέύϋΰήώΑ-ΩΆΈΊΌΎΏΉa-zA-Zs.-]+$/,
      message: 'Τα στοιχεία που καταχωρήσατε δεν είναι σωστά 😕',
    },
    email: {
      rendered: true,
      required: false,
      label: 'Email',
      placeholder: '',
      value: '',
      validation:
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@[A-Za-z0-9.-]{2,})+\.[A-Za-z]{2,}/,
      message: 'Το email που καταχωρήσατε δεν είναι έγκυρο 😕',
    },
    region: {
      rendered: false,
      required: false,
      label: 'Νομός',
      placeholder: '',
      value: '',
      message: '',
    },
    town: {
      rendered: false,
      required: false,
      label: 'Πόλη',
      placeholder: '',
      value: '',
    },
    zipCode: {
      rendered: false,
      required: false,
      label: 'Τ.Κ.',
      placeholder: '',
      value: '',
      validation: /^[0-9]{5}$/,
      message: 'Τα στοιχεία που καταχωρήσατε δεν είναι σωστά',
    },
    dateOfBirth: {
      rendered: true,
      required: false,
      label: 'Ημερομηνία γέννησης',
      placeholder: '',
      datePickerDoneButtonLabel: 'OK',
      datePickerCancelButtonLabel: 'Άκυρο',
      value: '',
      minValue: 18,
      maxValue: 100,
      message: 'Μη έγκυρη ημερομηνία. Δεν έχεις συμπληρώσει τα 18 έτη 😕',
    },
    nameDate: {
      rendered: false,
      required: false,
      nameDateDayPlaceholder: 'Ημέρα',
      nameDateMonthPlaceholder: 'Μήνας',
      nameDateLabel: 'Ημερομηνία Ονομαστικής Εορτής',
      nameDateDayValue: '',
      nameDateDayLabel: 'Ημέρα',
      nameDateMonthValue: '',
      nameDateMonthLabel: 'Μήνας',
      errorMessage: 'Πρέπει να επιλέξεις πρώτα μήνα',
    },
    singleConsent: {
      rendered: false,
      required: false,
      label: '',
    },
    smsConsent: {
      rendered: false,
      label: 'Με SMS',
      value: false,
      name: 'SMS ',
    },
    viberConsent: {
      rendered: false,
      label: 'Με instant messages (Viber κλπ)',
      value: false,
      name: 'VIBER ',
    },
    emailConsent: {
      rendered: false,
      label: 'Με Email',
      value: false,
      name: 'EMAIL ',
    },
    multiConsent: {
      rendered: false,
      required: false,
      label: '',
    },
    allConsent: {
      rendered: false,
      label: 'Με όλα τα παραπάνω',
      value: false,
    },
    isPersonalized: false,
    token: '',
    flowExecution: false,
    flowExecutionId: '',
    flowExecutionSubject: '',
  };

  register() {
    this.consentList.push(
      new Consent({
        name: 'SFM APP',
        flag: true,
        metadata: [{ key: 'Retail', value: 'OFFLINE' }],
      }),
      new Consent({
        name: 'SFM DIRECT CALL',
        flag: true,
        metadata: [{ key: 'Retail', value: 'OFFLINE' }],
      }),
      new Consent({
        name: 'SFM DIRECT MAIL',
        flag: true,
        metadata: [{ key: 'Retail', value: 'OFFLINE' }],
      }),
      new Consent({
        name: 'SFM EMAIL',
        flag: true,
        metadata: [{ key: 'Retail', value: 'OFFLINE' }],
      }),
      new Consent({
        name: 'SFM SMS',
        flag: true,
        metadata: [{ key: 'Retail', value: 'OFFLINE' }],
      }),
      new Consent({
        name: 'SFM SOCIALMEDIA',
        flag: true,
        metadata: [{ key: 'Retail', value: 'OFFLINE' }],
      }),
      new Consent({
        name: 'SFM VIBER',
        flag: true,
        metadata: [{ key: 'Retail', value: 'OFFLINE' }],
      })
    );

    const email =
      this.personDetailsFacadeService.email.length > 1
        ? [
            {
              emailAddress: this.personDetailsFacadeService.email,
              isPrimary: true,
              attributes: [],
            },
          ]
        : [];

    const person = {
      firstName: this.personDetailsFacadeService.firstName,
      lastName: this.personDetailsFacadeService.lastName,
      emailList: email,
      dateOfBirth: this.personDetailsFacadeService.dateOfBirth,
      telephoneList: [
        {
          telephoneNumber: this.otpValidationFacadeService.mobileNumber,
          countryCode: this.otpValidationFacadeService.countryCode,
          telephoneType: 'MOBILE',
          isPrimary: true,
        },
      ],
      loyaltyMembershipData: [
        {
          schemaCode: '2222',
          registrationCountryCode: 'cy',
          category: 'NormalMember',
          registrationSource: 'LANDING_PAGE',
          loyaltyCardData: {
            type: 'Permanent',
          },
        },
      ],

      consentList: this.consentList,
    };

    this.personDetailsFacadeService.dispatch(
      CreatePersonData({
        person,
      })
    );
  }
}
